// extracted by mini-css-extract-plugin
module.exports = {"container":"layout_container__wa5PY","h1":"layout_h1__GZjJd"};